import "./style/user.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import * as userActions from "../../../../actionCreators/User";
import * as dropDownActions from "../../../../actionCreators/DropDown";
import { Typography, Spin, Select, Pagination, Button, Input } from "antd";

const { Option } = Select;
const { Title } = Typography;

function AdminActivityLogs({
  admins,
  getAdmins,
  adminLogs,
  currentUser,
  getAdminActivityLogs,
}) {
  const history = useHistory();
  const [activityLogs, setActivityLogs] = useState(null);
  const [loading, setLoading] = React.useState(false);
  const [pagination, setPagination] = React.useState({});
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState("all");
  useEffect(() => {
    getAdminActivityLogs({
      page: page - 1,
      pageSize: pageSize,
      filter: filter,
    });
    getAdmins();
  }, []);
  useEffect(() => {
    if (adminLogs.data) {
      setActivityLogs(adminLogs.data);
      setLoading(adminLogs.loading);
      setPagination(adminLogs.pagination);
    }
  }, [adminLogs]);
  const handleTableChange = async (page, pageSize) => {
    setLoading(true);
    setPageSize(pageSize);
    setPage(page);
    getAdminActivityLogs({
      page: page - 1,
      pageSize: pageSize,
      filter: filter,
    });
  };
  const handleAdminFilters = async (filters) => {
    setFilter(filters);
    getAdminActivityLogs({
      page: page - 1,
      pageSize: pageSize,
      filter: filters,
    });
  };
  const template = (data) => {
    const action = data?.action;
    const date = new Date(data.createdAt).toLocaleString();
    return (
      <div className="activity-container">
        <div className="activity-header">{action}</div>
        <div className="activity-time">{date}</div>
      </div>
    );
  };

  return (
    <div>
      <div className="header">
        <Typography className="heading">Admin Activity Log</Typography>
      </div>
      <div className="logs-container" style={{ width: "100%" }}>
        <div className="logs-header">
          <Title level={4}>Activity Logs</Title>
          <Select
            defaultValue="all"
            className="admin-filter-dropdown"
            onChange={handleAdminFilters}
          >
            <Option value="all">All Admins</Option>
            {admins?.data?.map((data, index) => (
              <Option key={index} value={data.id}>
                {data.full_name}
              </Option>
            ))}
          </Select>
        </div>
        {loading ? (
          <div
            style={{
              width: "100%",
              height: "30vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin />
          </div>
        ) : activityLogs?.length === 0 ? (
          <div
            style={{
              width: "100%",
              height: "30vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              opacity: 0.5,
            }}
          >
            No Logs Found.
          </div>
        ) : (
          <div>
            {activityLogs &&
              activityLogs.map((data) => {
                let div = template(data);
                return div;
              })}
            <div className="pagination">
              <Pagination
                current={pagination.currentPage + 1}
                total={pagination.count}
                defaultPageSize={10}
                pageSize={pageSize}
                pageSizeOptions={["10", "20", "30"]}
                onChange={handleTableChange}
                showSizeChanger={true}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = ({
  user: { adminLogs, currentUser },
  dropDown: { admins },
}) => ({
  currentUser,
  adminLogs,
  admins,
});

const mapDispatchToProps = (dispatch) => ({
  getAdminActivityLogs: bindActionCreators(
    userActions.getAdminActivityLogs,
    dispatch
  ),
  getAdmins: bindActionCreators(dropDownActions.getAdmins, dispatch),
});

AdminActivityLogs.propTypes = {
  getAdminActivityLogs: PropTypes.func.isRequired,
  getAdmins: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminActivityLogs);
